/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import hashTagChecker from '@shared/utils/HashTagChecker';

// API's
import { getSearchForward } from '@shared/services/searchApi';
// styles
import './SearchSuggestion.css';

const checkSource = (sourceUrl) => {
  switch (sourceUrl) {
  case '/':
    return 'Homepage';
  case '/live':
    return 'Browse';
  case '/klips':
    return 'Klips';
  case '/search/index':
    return 'Search';
  case '/coins':
    return 'Buy Coins';
  case '/coins/payment':
    return 'Buy Coins';
  case '/coins/payment/status':
    return 'Buy Coins';
  case '/wallet':
    return 'Wallet';
  case '/wallet-error-page':
    return 'Wallet';
  default:
    return 'User Profile';
  }
};

const trackSearchInitiated = (method, keyword, sourceUrl) => {
  const sourceInfo = checkSource(sourceUrl);
  window.analytics.track('Search Initiated', {
    input_method: method,
    search_input: keyword,
    source: sourceInfo,
  });
};

const useKeyPress = function (targetKey) {
  const [keyPressed, setKeyPressed] = useState(false);

  function downHandler({ key }) {
    if (key === targetKey) {
      setKeyPressed(true);
    }
  }

  const upHandler = ({ key }) => {
    if (key === targetKey) {
      setKeyPressed(false);
    }
  };

  useEffect(() => {
    const searchInput = document.getElementById('search-input-field');
    if (searchInput) {
      searchInput.addEventListener('keydown', downHandler);
      searchInput.addEventListener('keyup', upHandler);
    }
  });

  return keyPressed;
};

function ListItem({
  item,
  active,
  setSelected,
  setHovered,
  index,
  setSuggestion,
  selected,
  hovered,
  sourceUrl,
}) {
  const searchInput = document.getElementById('search-input-field');
  let getValue = '';
  if (searchInput && selected !== '') {
    searchInput.value = selected;
    getValue = selected;
  } else if (searchInput) {
    getValue = searchInput.value;
  }

  function setSelectedKeyword(keyword) {
    setSelected(keyword);
    trackSearchInitiated('suggestion', keyword, sourceUrl);
  }

  return (
    <div
      key={index}
      className={`typeahead-item ${active ? 'active' : 'unactive'}`}
      onClick={() => setSelectedKeyword(item)}
      onMouseEnter={() => setHovered(item)}
      onMouseLeave={() => setHovered(undefined)}
    >
      <Link to={`/search/index?s=${hashTagChecker(hovered || getValue)}`} className='typeahead-link' onClick={() => setSuggestion([])}>
        <span>{item}</span>
      </Link>
    </div>
  );
}
function SearchSuggestion({
  input,
  suggestion,
  setSuggestion,
  sourceUrl,
}) {
  const [selected, setSelected] = useState('');
  const downPress = useKeyPress('ArrowDown');
  const upPress = useKeyPress('ArrowUp');
  const enterPress = useKeyPress('Enter');
  const [cursor, setCursor] = useState(0);
  const [hovered, setHovered] = useState(undefined);

  useEffect(() => {
    if (suggestion.length && downPress) {
      setCursor((prevState) => (prevState < suggestion.length - 1 ? prevState + 1 : prevState));
    }
  }, [downPress, suggestion.length]);
  useEffect(() => {
    if (suggestion.length && upPress) {
      setCursor((prevState) => (prevState > 0 ? prevState - 1 : prevState));
    }
  }, [suggestion.length, upPress]);
  useEffect(() => {
    if (upPress || downPress) {
      setSelected(suggestion[cursor]);
    }
  }, [cursor, downPress, enterPress, suggestion, upPress]);
  useEffect(() => {
    if (suggestion.length && hovered) {
      setCursor(suggestion.indexOf(hovered));
    }
  }, [hovered, suggestion]);

  // Search API calls
  const searchForwardAPI = (keyword) => {
    getSearchForward(keyword)
      .then((response) => {
        if (response.data.code === '200' && response.data.status === 'success') {
          setSuggestion(response.data.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // equivalent to componentDidMount, fires once when component mounts
  useEffect(() => {
    const searchValue = hashTagChecker(input);
    if (input.trim().length > 0) {
      setTimeout(() => {
        searchForwardAPI(searchValue);
      }, 300);
    } else {
      setSuggestion([]);
    }
  }, [input]);
  return (
    <>
      {input.length > 0 && suggestion.length > 0
                && (
                  <div className='typeahead'>
                    <div className='typeahead-list' id='search-list'>
                      {suggestion.map((channel, index) => (
                        <ListItem
                          key={index}
                          active={index === cursor}
                          item={channel}
                          setSelected={setSelected}
                          setHovered={setHovered}
                          index={index}
                          setSuggestion={setSuggestion}
                          selected={selected}
                          hovered={hovered}
                          sourceUrl={sourceUrl}
                        />
                      ))}
                    </div>
                  </div>
                )}
    </>
  );
}
export default SearchSuggestion;
